import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./besan.css";
import ProductCard from "../../components/productCard/ProductCard";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";

const Besan = () => {
  return (
    <>
      <Navb />
      <div className="besanmaintop">
        <div className="daliatoptext">
          Nandi Besan: Transforming <br /> Traditional Flavors for Every Indian{" "}
          <br /> Home
        </div>
        <img
          src={Img2}
          alt="Img2"
          style={{ display: "block", padding: "8px 50px 0px" }}
        />
      </div>

      <div className="whiteComponentsingleEcavo bg3">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Besan"
          text="Nandi’s Besan is the epitome of quality and flavor, meticulously crafted to elevate your culinary creations. Sourced from the finest gram, our Besan is a versatile ingredient that forms the foundation of countless savory and sweet delicacies. Whether you're craving crispy pakoras, fluffy dhoklas, or decadent besan ladoos, Nandi’s Besan promises exceptional taste and texture in every bite. With our commitment to excellence and tradition, Nandi’s Besan is your go-to choice for authentic flavor and unparalleled quality."
          link1="/recipes/besanburfi"
          link1Text="View Recipes"
          link2="https://ecavo.shop/products/besan"
          linkClass="blackButton"
          //   sideImg={Sideimg1}
          headingcss="blackHeading"
          pcss="blackP"
        />
      </div>
      <div className="productCards">
        <ProductCard
          Heading="Hygienic Production"
          Text="Nandi’s Besan is produced under stringent hygienic conditions, ensuring purity and safety in every bite. With quality control measures in place, you can trust that each serving of Nandi's Dalia meets the highest standards of cleanliness and food safety."
        />
        <ProductCard
          Heading="Nutritional Superiority"
          Text="Nandi’s Besan is not only rich in protein but also boasts high levels of essential nutrients, contributing to overall health and vitality."
        />
        <ProductCard
          Heading="Culinary Innovation"
          Text="Nandi’s Besan inspires culinary creativity, offering a canvas for experimenting with diverse recipes and flavors. Its unique characteristics lend themselves to traditional and contemporary dishes alike, sparking culinary innovation and delighting taste buds with each creation."
        />
      </div>
      <Footer />
    </>
  );
};

export default Besan;
